var jsonData = JSON.parse(document.querySelector('[data-product-json]').innerHTML);
var pageOverlay = document.querySelector('.PageOverlay');
var form = document.querySelector('#product_form_' + jsonData.product.id);

var drawers = document.querySelectorAll('.gr-drawer');
var drawerToggles = document.querySelectorAll('[data-drawer-toggle]');

function openDrawer(toggle) {
  document.querySelectorAll(`.gr-drawer`).forEach(i => i.classList.remove('open'))
  var drawer = document.querySelector(`.gr-drawer[data-drawer="${ toggle }"]`);
  if (drawer) {
    drawer.classList.add('open');
    pageOverlay.classList.add('is-visible');
  }
}

function closeDrawer(drawer) {
  drawer.classList.remove('open')
  pageOverlay.classList.remove('is-visible');
}

let previousVariant = null;

function variantUpdated(currentVariant) {
  if (!currentVariant) {
    var formData = new FormData(form);
    var variant = {
      option1: formData.get('option-0'),
      option2: formData.get('option-1'),
      option3: formData.get('option-2')
    }
  } else {
    var variant = {
      option1: currentVariant.option1,
      option2: currentVariant.option2,
      option3: currentVariant.option3
    }

    previousVariant = currentVariant;
  }

  var values = document.querySelectorAll('.gr-value');

  values.forEach(function(item) {
    var itemPriceElm = item.querySelector('[data-price]');
    var itemStatusElm = item.querySelector('[data-status]');

    var itemValue = item.dataset.value;
    var itemOption = item.dataset.option;
    var findValidVariant = jsonData.product.variants.find(i => i[`option${ +itemOption + 1 }`] === itemValue);


    if (findValidVariant) {

      if (itemValue === variant[`option${ +itemOption + 1 }`]) {
        item.classList.add('active');
        var optionInput = document.querySelector(`input[data-option-position="${ +itemOption + 1 }"][value="${ itemValue }"]`)
        if (optionInput && optionInput.dataset.optionPosition === '1') {
          var scrollable = optionInput.closest('.HorizontalList');
          scrollable.scroll(optionInput.parentElement.offsetLeft - (scrollable.offsetWidth / 2) + (optionInput.parentElement.offsetWidth / 2), 0)
        }
      } else {
        item.classList.remove('active');
      }


      const variantCopy = JSON.parse(JSON.stringify(variant));
      variantCopy[`option${ +itemOption + 1 }`] = itemValue;

      var itemVariant = jsonData.product.variants.find(i => i.option1 === variantCopy.option1 && i.option2 === variantCopy.option2 && i.option3 === variantCopy.option3);


      if (itemVariant) {
        var selectedVariant = currentVariant || previousVariant;
        itemPriceElm.textContent = `${ (itemVariant.price - selectedVariant.price) >= 0 ? '+' : '-' } ${ slate.Currency.formatMoney(Math.abs(selectedVariant.price - itemVariant.price), window.theme.moneyFormat) }`;
        itemStatusElm.textContent = itemVariant.available ? languages.variantAvailable : languages.variantUnavailable;

        if (!itemVariant.available) {
          itemStatusElm.classList.add('unavailable');
          item.classList.add('disabled');
        } else {
          itemStatusElm.classList.remove('unavailable');
          item.classList.remove('disabled');
        }
      }
    } else {
      item.classList.remove('active');
      item.classList.add('disabled');
      itemStatusElm.textContent = languages.variantUnavailable;
      itemPriceElm.textContent = '';
      itemStatusElm.classList.add('unavailable');
    }
  })

  var skuElm = document.querySelectorAll('[data-product-sku]');

  if (currentVariant) {
    var selectedVariant = currentVariant.sku;
  } else {
    var selectedVariant = '';
  }

  skuElm.forEach(i => i.textContent = selectedVariant)
}

function updateProductStatus(variant) {
  var statusWrapper = document.querySelector('.gr-product-info__tab[data-drawer-toggle="delivery"]');

  if (statusWrapper) {
    var titleElm = statusWrapper.querySelector('.gr-product-info__title');

    if (!theme.productIsPreOrder && titleElm) {
      titleElm.textContent = variant.available ? languages.productInStock : languages.productOutOfStock
      if (variant.available) titleElm.classList.remove('soldOut');
      else titleElm.classList.add('soldOut');
    }
  }
}

drawers.forEach(function(drawer) {
  var drawerClose = drawer.querySelector('.gr-drawer__close');

  drawerClose.addEventListener('click', function() {
    closeDrawer(drawer);
  });

  var values = drawer.querySelectorAll('.gr-value');

  values.forEach(function(item) {
    var value = item.dataset.value;
    var option = item.dataset.option;

    item.addEventListener('click', function() {
      values.forEach(i => i.classList.remove('active'));
      item.classList.add('active');

      var optionInput = document.querySelector(`input[name="option-${ option }"][value="${ value }"]`);
      if (optionInput) {
        optionInput.click();

        optionInput.closest('.HorizontalList__Item').scrollIntoView({
          behavior: 'smooth', block: 'nearest', inline: 'center'
        });
      }

      var openDrawer = document.querySelector('.gr-drawer.open');
      if (openDrawer) {
        closeDrawer(openDrawer);
      }
    })
  })
})

drawerToggles.forEach(function(toggle) {
  toggle.addEventListener('click', function() {
    openDrawer(toggle.dataset.drawerToggle)
  })
})


function updateDiscountLabel(variant) {
  const labels = document.querySelectorAll('[data-discount]');

  if (!labels) {
    return;
  }

  labels.forEach((label) => label.hidden = true);
  const matchingLabel = Array.from(labels).find((label) => label.dataset.discount === variant.id.toString());

  if (matchingLabel) {
    matchingLabel.hidden = false;
  }
}


document.addEventListener('variant:changed', function(evt) {
  variantUpdated(evt.detail.variant);
  updateProductStatus(evt.detail.variant)
  updateDiscountLabel(evt.detail.variant)
})

pageOverlay.addEventListener('click', function() {
  var openDrawer = document.querySelector('.gr-drawer.open');
  if (openDrawer) {
    closeDrawer(openDrawer);
  }
})

variantUpdated(jsonData.product.variants.find(i => i.id === jsonData.selected_variant_id))

var loadImages = document.querySelectorAll('.gr-load-more-images');
if (loadImages) {
  loadImages.forEach(loadImage => {
    loadImage.addEventListener('click', function() {
      loadImage.classList.add('active');
    })

  });
}



/**
 * Represents a custom HTML element for handling variant media.
 * @class
 * @extends HTMLElement
 */

class VariantMedia extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.eventTrigger = this.eventTrigger.bind(this);
    document.addEventListener('variant:changed', this.eventTrigger);

    this.matchingVariants = this.getAttribute('matching-variants');
    this.variantSlider = this.querySelector('.Product__Variant-slideshow');

    // Add event listener for matching media on mobile
    const mediaQuery = window.matchMedia('(max-width: 1007px)');

    // Initial check for matching media
    this.handleMediaChange(mediaQuery);

    // Add event listener for media query changes
    mediaQuery.addEventListener('change', this.handleMediaChange);
    this.addEventListener("lightbox:open", (event) => this.openLightBox(event?.detail?.index));

    this._attachListeners();
  }

  openLightBox(index) {
    const images = [...this.querySelectorAll('.Product__Variant-media .Product__SlideItem--image img')];
    const dataSource = images.map((image) => {
      return {
        src: image.currentSrc || image.src || image.getAttribute('data-original-src'),
        srcset: image.srcset || image.dataset.srcset,
        msrc: image.currentSrc || image.src || image.getAttribute('data-original-src'),
        width: parseInt(image.getAttribute('data-max-width')),
        height: parseInt(image.getAttribute('data-max-height')),
        alt: image.alt,
        thumbCropped: true
      };
    });
    this.lightBox.loadAndOpen(index ?? 0, dataSource);
  }

  disconnectedCallback() {
    document.removeEventListener('variant:changed', (this.eventTrigger));
  }

  handleMediaChange = (mediaQuery) => {
    if (mediaQuery.matches) {
      // Horrible fix because vendor.js delayed and too much work to fix it properly
      setTimeout(() => {
        const flickityOptions = JSON.parse(this.variantSlider.dataset.flickityConfig);
        this.slider = new Flickity(this.variantSlider, flickityOptions);
      }, 200);
    } else {
      if (this.slider) {
        this.slider.destroy();
      }
    }
  };

  eventTrigger(event) {
    this.showContent(event.detail.variant);
  }

  showContent(variant) {
    this.hidden = !this.matchingVariants.includes(variant.id);

    if (this.slider) {
      this.slider.resize()
    }
  }

  _attachListeners() {
    this.element = this;
    this.delegateElement = new domDelegate.Delegate(this.element);
    this.delegateRoot = new domDelegate.Delegate(document.body);

    this.delegateElement.on('click', '[data-action="open-product-zoom"]', this._initPhotoSwipe.bind(this));
    this.delegateElement.on('click', '.Product__Variant-media .Product__SlideItem--image', this._initPhotoSwipe.bind(this));
  }

  _initPhotoSwipe(event, target) {
    const index = this.slider?.selectedElement?.getAttribute('data-image-media-position') || target.getAttribute('data-image-media-position') || 0
    this.dispatchEvent(new CustomEvent("lightbox:open", { bubbles: true, detail: { index: parseInt(index) } }));
  }

  get lightBox() {
    if (this.photoSwipeInstance) {
      return this.photoSwipeInstance;
    }

    this.photoSwipeInstance = new PhotoSwipeLightbox({
      pswpModule: PhotoSwipe,
      bgOpacity: 1,
      maxZoomLevel: 3,
      tapAction: () => { },

      // UX
      arrowPrev: false,
      arrowNext: false,
      counter: false,
      close: false,
      zoom: false
    })

    this.photoSwipeInstance.on("uiRegister", this._registerLightboxUi.bind(this))
    this.photoSwipeInstance.addFilter("thumbEl", (thumbEl, data) => data.thumbnailElement)
    this.photoSwipeInstance.init();

    return this.photoSwipeInstance
  }

  _registerLightboxUi() {
    this.photoSwipeInstance.pswp.ui.registerElement({
      name: "close-button",
      className: "circle-button circle-button--xl",
      ariaLabel: 'Close',
      order: 2,
      isButton: true,
      html: `
        <svg aria-hidden="true" focusable="false" fill="none" width="16" viewBox="0 0 16 16">
          <path d="m1 1 14 14M1 15 15 1" stroke="currentColor" stroke-width="1"></path>
        </svg>
      `,
      onClick: () => {
        this.photoSwipeInstance.pswp.close();
      }
    });
    if (this.photoSwipeInstance.pswp.options.dataSource.length > 1) {
      this.photoSwipeInstance.pswp.ui.registerElement({
        name: "previous-button",
        className: "circle-button",
        ariaLabel: 'Previous',
        order: 1,
        isButton: true,
        html: `
        <svg aria-hidden="true" focusable="false" fill="none" width="16" viewBox="0 0 16 18">
          <path d="M11 1 3 9l8 8" stroke="currentColor" stroke-linecap="square"></path>
        </svg>
      `,
        onClick: () => {
          this.photoSwipeInstance.pswp.prev();
        }
      });
      this.photoSwipeInstance.pswp.ui.registerElement({
        name: "next-button",
        className: "circle-button",
        ariaLabel: 'Next',
        order: 3,
        isButton: true,
        html: `
        <svg aria-hidden="true" focusable="false" fill="none" width="12" viewBox="0 0 16 18">
          <path d="m5 17 8-8-8-8" stroke="currentColor" stroke-linecap="square"></path>
        </svg>
      `,
        onClick: () => {
          this.photoSwipeInstance.pswp.next();
        }
      });
    }
  }
}
customElements.define('variant-media', VariantMedia);



(function() {

  const activeProductOptions = document.querySelectorAll('.gr-option-wrapper input:checked');
  activeProductOptions.forEach(activeProductOption => {
    const item = activeProductOption.closest('.HorizontalList__Item');
    item.parentElement.scrollLeft = item.offsetLeft
  });

})();
